import { Box } from '@mui/system';
import React from 'react'

const percentile = (arr, value) => {
  const currentIndex = 0;
  const totalCount = arr.reduce((count, currentValue) => {
    if (currentValue < value) {
      return count + 1; // add 1 to `count`
    } else if (currentValue === value) {
      return count + 0.5; // add 0.5 to `count`
    }
    return count + 0;
  }, currentIndex);
  return (totalCount * 100) / arr.length;
};

const ConditionalFormat = ({children, dataSet, cellValue}) => {
  const percentileValue = percentile(dataSet, cellValue);

  const getBackgroundColor = () => {
    if(percentileValue >= 80) {
      const opacity = 1 - ((100 - percentileValue) * .05);
      return `rgba(0, 88, 46, ${opacity})`;
    } else if(percentileValue <= 20) {
      const opacity = 1 - (percentileValue / 20);
      return `rgba(138, 0, 15, ${opacity})`;
    }
  }

  return (
    <Box bgcolor={`${getBackgroundColor()}`} width='100%' height='100%' display='flex' alignItems='center' justifyContent='center'>
      {children}
    </Box>
  )
}

export default ConditionalFormat